// Unpublished Work © 2020-2024 Deere & Company.

export default {
    AGRONOMY_ID: 'c4399fae-0556-460f-95ee-0624486bb3ba',
    EQUIPMENT_ID: 'c6eaafe3-77ff-4741-9c3c-140d26f302f4',
    GENERAL_ID: '69817ac6-2960-4cdb-80f7-41b0755b939c',
    PROPERTY_ID: '2b0520fc-d221-4393-9053-657c827128b6'
};
